import { useState } from "react";
import SecondaryButton from "../../../buttons/SecondaryButton";
import InfiltreaFolder from "../../../folder_modals/InfiltreaFolder";
import PennylaneFolder from "../../../folder_modals/PennylaneFolder";
import CustomAccordion from "../../../layout/CustomAccordion";
import Space from "../../../layout/Space";
import { queryCollection } from "../../../models/DataFunctions";
import { format } from "date-fns";
import Icon1 from "../../../icons/Icon";
import { hasInfiltro } from "../../../hexagone/VisibilityHelpers";

export const FolderActivitySection = ({
  orgData,
  userData,
  handleFetchData,
  missions_infiltrea,
  invoices_pennylane,
  folderData,
  activity_logs,
  emails,
}) => {
  return (
    <>
      <div className=" flex flex-col gap-1">
        <CustomAccordion title="Activité détaillée" userData={userData}>
          <div className="flex flex-col gap-1 mb-4 mt-2 max-w-full w-full">
            {activity_logs
              .sort((a, b) => b.date.toDate() - a.date.toDate())
              .map((log, index) => (
                <div
                  key={index}
                  className={`relative flex flex-row max-w-full gap-2 items-center hover:bg-slate-50 ${log.name === "Ouverture du dossier" ? "text-shadow_25" : "text-shadow_50"}`}
                >
                  <div className=" min-w-1   w-1 h-1 rounded-full bg-shadow_10 ml-2"></div>

                  {index !== activity_logs.length - 1 && (
                    <div className="absolute  w-0 h-3 border-r-1 left-0.5 top-4 border-shadow_5 ml-2"></div>
                  )}
                  <div className="text-h3  min-w-c150">
                    {format(log.date.toDate(), "dd/MM/yyyy HH:mm")}
                  </div>
                  <div
                    className={`text-h3  w-full text-nowrap overflow-x-clip `}
                  >
                    {log.name?.substring(0, 60)}
                  </div>
                  <div
                    className={`text-h3  w-c200 min-w-c100 text-nowrap overflow-x-clip `}
                  >
                    {log.user_name}
                  </div>
                  <div className="text-h3  w-c200 min-w-c100  text-nowrap overflow-x-clip">
                    {log.org_name}
                  </div>
                </div>
              ))}
          </div>
        </CustomAccordion>
      </div>
    </>
  );
};
